import React from "react";
import { Filter } from "lucide-react";
import { TipId } from "../../../constants/Enums";

export interface TipConfig {
  id: TipId;
  /** CSS selector used to locate the target element at runtime */
  anchorSelector: string;
  /** Route prefix — tip only fires when pathname starts with this string */
  routePrefix: string;
  icon: React.ReactNode;
  message: string;
  /** How long (ms) to hold the card before auto-swallowing. Default 2200 */
  holdMs?: number;
}

// ─────────────────────────────────────────────────────────────────────────────
// THE ONLY FILE YOU NEED TO EDIT TO ADD / REMOVE / TWEAK A TIP
// ─────────────────────────────────────────────────────────────────────────────
const TIP_REGISTRY: TipConfig[] = [
  {
    id: TipId.USER_LISTINGS_FILTER_TAGS,
    anchorSelector: ".fd-trigger",
    routePrefix: "/listings/",
    icon: <Filter size={22} />,
    message: "Filter listings by tags",
  },
];

export default TIP_REGISTRY;
